import { FormControl, FormLabel, Switch, Box, VStack, Text, useColorModeValue } from '@chakra-ui/react';
import { useAtom } from 'jotai';
import { useCacheFirstAtom } from '../../atoms/v0/uiAtoms';
import { useTranslation } from 'react-i18next';

export const DataLoadingPreferences = () => {
  const [useCacheFirst, setUseCacheFirst] = useAtom(useCacheFirstAtom);
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const { t } = useTranslation(['v0/me', 'v0/common']);

  return (
    <Box 
      p={4} 
      bg={bgColor} 
      borderWidth="1px" 
      borderColor={borderColor} 
      borderRadius="md"
      boxShadow="sm"
    >
      <VStack align="stretch" spacing={4}>
        <Text fontWeight="medium">{t('v0/common:me.dataLoading.title')}</Text>
        <FormControl display="flex" alignItems="center" justifyContent="space-between">
          <FormLabel htmlFor="cache-first" mb="0" fontSize="sm">
            {t('v0/common:me.dataLoading.cacheFirst')}
          </FormLabel>
          <Switch 
            id="cache-first" 
            isChecked={useCacheFirst} 
            onChange={(e) => setUseCacheFirst(e.target.checked)}
            colorScheme="teal"
          />
        </FormControl>
        <Text fontSize="xs" color="gray.500">
          {t('v0/common:me.dataLoading.description')}
        </Text>
      </VStack>
    </Box>
  );
}; 